module.exports = __webpack_public_path__ + "img/apply-avatar.16ff91fa.jpg";